import { createTheme } from '@mui/material/styles';
import '../styles/global.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: '#048091', // Colore principale
    },
    secondary: {
      main: '#7E82F7', // Colore secondario
    },
    background: {
      default: '#101010',
    },
  },
  typography: {
    fontFamily: 'Inder, sans-serif',
  },
});

export default theme;